import { Deserializable } from '../protocols/deserializable';

export class NewMemberVerificationResponse implements Deserializable {
  public firstName!: string;
  public lastName!: string;
  public socialInsuranceNumber!: string;
  public birthDate!: string;
  public potentialMatches: NewMemberPotentialMatch[] = [];

  public onDeserialize(): void {
    const deserialize = window?.injector?.Deserialize;
    this.potentialMatches = deserialize?.arrayOf(NewMemberPotentialMatch, this.potentialMatches);
  }
}

export class NewMemberPotentialMatch implements Deserializable {
  public memberId!: number;
  public firstName!: string;
  public lastName!: string;
  public socialInsuranceNumber!: string;
  public birthDate!: string;
  public onDeserialize(): void {}
}
